import { render, staticRenderFns } from "./CustomSwiper.vue?vue&type=template&id=5a30673e&scoped=true&lang=pug&"
import script from "./CustomSwiper.vue?vue&type=script&lang=js&"
export * from "./CustomSwiper.vue?vue&type=script&lang=js&"
import style0 from "./CustomSwiper.vue?vue&type=style&index=0&id=5a30673e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a30673e",
  null
  
)

export default component.exports